// Helpers for reconciling UTC datetimes from the API with the browser's LOCAL
// zone. The backend runs in Africa/Lagos and serializes datetimes as UTC (…Z),
// so naively slicing an ISO string shows the UTC wall-clock — an hour behind
// WAT. These convert properly.

/** UTC ISO -> value for an <input type="datetime-local"> (local "YYYY-MM-DDTHH:mm"). */
export function toLocalInput(iso?: string | null): string {
  if (!iso) return "";
  const d = new Date(iso);
  if (isNaN(d.getTime())) return "";
  return new Date(d.getTime() - d.getTimezoneOffset() * 60000).toISOString().slice(0, 16);
}

/** UTC ISO -> a "YYYY-MM-DD HH:mm" label in local time (for read-only display). */
export function toLocalDisplay(iso?: string | null): string {
  const v = toLocalInput(iso);
  return v ? v.replace("T", " ") : "—";
}

/** datetime-local value (local wall-clock) -> absolute UTC ISO for the server. */
export function toUtcIso(local?: string | null): string | null {
  if (!local) return null;
  const d = new Date(local);
  return isNaN(d.getTime()) ? null : d.toISOString();
}
